import { render, staticRenderFns } from "./PeopleAvatar.vue?vue&type=template&id=158d84f0&scoped=true&"
import script from "./PeopleAvatar.vue?vue&type=script&lang=js&"
export * from "./PeopleAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PeopleAvatar.vue?vue&type=style&index=0&id=158d84f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d84f0",
  null
  
)

export default component.exports